import { type ChangeEvent, type Dispatch, type SetStateAction } from "react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

interface FinalizarFields {
  contacto: string;
  nombreMuestra: string;
  atencion: string;
  autorizo: string;
  superviso: string;
  numeroAcreditacion: string;
  imagen: File | null;
}

interface FinalizarPedidoModalProps {
  open: boolean;
  onClose: () => void;
  finalizarFields: FinalizarFields;
  setFinalizarFields: Dispatch<SetStateAction<FinalizarFields>>;
  finalizarLoading: boolean;
  isSaving: boolean;
  imagenError: string | null;
  handleImageChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleSave: () => Promise<void>;
}

export function FinalizarPedidoModal({
  open,
  onClose,
  finalizarFields,
  setFinalizarFields,
  finalizarLoading,
  isSaving,
  imagenError,
  handleImageChange,
  handleSave,
}: FinalizarPedidoModalProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Datos para cierre de pedido</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Contacto</label>
            <Input
              value={finalizarFields.contacto}
              onChange={e => setFinalizarFields(f => ({ ...f, contacto: e.target.value }))}
              placeholder="Nombre del contacto"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Nombre de la muestra</label>
            <Input
              value={finalizarFields.nombreMuestra}
              onChange={e => setFinalizarFields(f => ({ ...f, nombreMuestra: e.target.value }))}
              placeholder="Nombre de la muestra"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Con atención a</label>
            <Input
              value={finalizarFields.atencion}
              onChange={e => setFinalizarFields(f => ({ ...f, atencion: e.target.value }))}
              placeholder="Persona a quien va dirigido"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Autorizó</label>
            <Input
              value={finalizarFields.autorizo}
              onChange={e => setFinalizarFields(f => ({ ...f, autorizo: e.target.value }))}
              placeholder="Nombre de quien autoriza"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Supervisó</label>
            <Input
              value={finalizarFields.superviso}
              onChange={e => setFinalizarFields(f => ({ ...f, superviso: e.target.value }))}
              placeholder="Nombre de quien supervisa"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Número de acreditación</label>
            <Select
              value={finalizarFields.numeroAcreditacion}
              onValueChange={value => setFinalizarFields(f => ({ ...f, numeroAcreditacion: value }))}
            >
              <SelectTrigger>
                <SelectValue placeholder="Seleccione número de acreditación" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="TV-1960-015/25">TV-1960-015/25</SelectItem>
                <SelectItem value="Q-1959-302/25">Q-1959-302/25</SelectItem>
                <SelectItem value="MM-1958-253/25">MM-1958-253/25</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Subir Imagen</label>
            <Input
              type="file"
              accept=".jpg,.jpeg,.png"
              onChange={handleImageChange}
            />
            {imagenError && <p className="text-red-600 text-sm mt-1">{imagenError}</p>}
          </div>
        </div>
        <DialogFooter>
          <div className="flex justify-end gap-4">
            <Button variant="outline" onClick={onClose}>
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="default"
              disabled={
                finalizarLoading ||
                !(
                  finalizarFields.superviso.trim() &&
                  finalizarFields.numeroAcreditacion.trim()
                )
              }
              onClick={handleSave}
            >
              {isSaving ? 'Renderizando Pruebas...' : 'Guardar'}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
